export default {"src":"/_next/static/media/small-dog.abb18516.svg","height":101,"width":100};